<app-application-details [application]="application"></app-application-details>

<app-application-education-details [educationDetails]="$safeNavigationMigration(application?.educationDetails)">
</app-application-education-details>


@for (experience of workExperiences; track experience; let i = $index) {
  <section class="placement mt-4" style="margin:0; padding: 0"
    [class.first]="i===0" [class.allow-edit]="!readonly">
    <h3 class="mb-3">
      <div class="grow">Your {{nth(i)}} placement</div>
    </h3>
    <app-work-experience [workExperience]="experience" [readonly]="true"></app-work-experience>
  </section>
}

<app-application-supporting-docs [application]="application" [isStudent]="false"></app-application-supporting-docs>

<app-application-ftp [application]="application"></app-application-ftp>